import { useQuery } from '@tanstack/react-query';
import { useSetAtom } from 'jotai';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { workflowAtom } from '../../atoms';
import { WorkflowServerExpect } from '../../ServerWorkflowType';
import { fetchWorkflowById } from './workflowByIdService';

interface UseWorkflowByIdReturn {
  error: Error | null;
  isError: boolean;
  isFetching: boolean;
  isLoading: boolean;
  workflow: WorkflowServerExpect | undefined;
}

export const useWorkflowById = (): UseWorkflowByIdReturn => {
  const [searchParameters] = useSearchParams();
  const name = searchParameters.get('name');

  const {
    data: workflow,
    isLoading,
    isError,
    isFetching,
    error,
  } = useQuery<WorkflowServerExpect>({
    enabled: !!name,
    queryFn: () => fetchWorkflowById(name),
    queryKey: ['workflow', name],
    refetchIntervalInBackground: false,
    refetchOnMount: true,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  });
  const setWorkflow = useSetAtom(workflowAtom);
  useEffect(() => {
    if (workflow) {
      setWorkflow(workflow);
    }
  }, [setWorkflow, workflow]);
  return {
    error,
    isError,
    isFetching,
    isLoading,
    workflow,
  };
};
